import React from 'react';
import './LegalPage.css';

const TermsAndConditions = () => {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <p className="legal-kicker">Terms</p>
        <h1>Terms and Conditions</h1>
        <p className="legal-meta">Last updated: January 6, 2025</p>
        <p className="legal-lead">
          These terms govern your use of Arrow.AI. By accessing the service, you agree to use it lawfully, respect other users, and understand that we route your prompts to the AI provider you choose without reading your messages ourselves. Accounts flagged for illegal or abusive activity may be suspended or deleted.
        </p>
      </header>

      <div className="legal-card">
        <section className="legal-section">
          <h3>Acceptance of Terms</h3>
          <p>
            By creating an account or using Arrow.AI, you agree to these Terms and Conditions and any policies referenced here, including our Privacy Policy. If you do not agree, please do not use the service.
          </p>
        </section>

        <section className="legal-section">
          <h3>Eligibility and Account Security</h3>
          <ul className="legal-list">
            <li>You must provide accurate registration information and keep your credentials secure.</li>
            <li>You are responsible for all activity that occurs under your account.</li>
            <li>We may suspend or delete accounts flagged for suspected abuse, illegal behavior, or security risk, with or without notice.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>Acceptable Use</h3>
          <ul className="legal-list">
            <li>No illegal, harmful, or abusive behavior, including harassment, hate, or exploitation.</li>
            <li>No attempts to disrupt or gain unauthorized access to the service or other users' data.</li>
            <li>No use of the service to distribute malware, spam, or content that violates applicable laws.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>AI Providers and Content</h3>
          <ul className="legal-list">
            <li>We route your prompts and content to the AI provider you select for that request.</li>
            <li>We do not monitor or read your messages; automated handling is used solely to deliver and return responses.</li>
            <li>You are responsible for the content you submit and for reviewing responses before relying on them.</li>
            <li>Provider-specific terms or usage limits may also apply when you select that provider.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3>Privacy</h3>
          <p>
            Our Privacy Policy explains how we handle your information. In short, we do not sell personal data, we store only your name, email, and messages, and you can delete your messages or account data at any time.
          </p>
        </section>

        <section className="legal-section">
          <h3>Payments and Subscriptions</h3>
          <p>
            If your plan includes paid features, you agree to provide accurate billing information and to the pricing and renewal terms presented at checkout. Fees are non-refundable except where required by law.
          </p>
        </section>

        <section className="legal-section">
          <h3>Termination</h3>
          <p>
            You may stop using Arrow.AI at any time. We may suspend or terminate access immediately if we believe an account is engaged in illegal activity, violates these terms, or poses a risk to the platform or other users, including when an account is flagged for prohibited behavior.
          </p>
        </section>

        <section className="legal-section">
          <h3>Disclaimers</h3>
          <p>
            Arrow.AI is provided "as is" without warranties of any kind. AI-generated content may be inaccurate or inappropriate; you should evaluate responses before acting on them.
          </p>
        </section>

        <section className="legal-section">
          <h3>Limitation of Liability</h3>
          <p>
            To the fullest extent permitted by law, Arrow.AI and its affiliates will not be liable for indirect, incidental, special, consequential, or punitive damages, or for loss of data, profits, or business opportunities arising from your use of the service.
          </p>
        </section>

        <section className="legal-section">
          <h3>Contact</h3>
          <p>
            For questions about these terms, contact us at support@arrow.ai.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
